import { Component, OnInit, ChangeDetectorRef, OnDestroy, HostListener } from '@angular/core';
import * as OT from '@opentok/client';
import { OpentokService } from 'src/app/services/opentok.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { Subscription } from 'rxjs';
import { VideoSettings } from 'src/app/redux/ui.reducer';
import { SetVideoSettings } from 'src/app/redux/ui.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { ReviewComponent } from '../review/review.component';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import Swal from 'sweetalert2';


@Component({
    selector: 'app-video-chat',
    templateUrl: './video-chat.component.html',
    styleUrls: ['./video-chat.component.scss'],
    standalone: false
})
export class VideoChatComponent implements OnInit, OnDestroy {
  title = 'Angular Basic Video Chat';
  session: OT.Session;
  streams: Array<OT.Stream> = [];
  remoteConnections: string[] = [];
  changeDetectorRef: ChangeDetectorRef;
  uiSUbscription: Subscription = new Subscription();
  video:VideoSettings = {
    video: true,
    audio: true
  }
  dateId = "";
  isExpanded = false;
  controlsVisible = true;
  private controlsHideTimer: ReturnType<typeof setTimeout>;
  constructor(
    private ref: ChangeDetectorRef, 
    private router: Router,
    private opentokService: OpentokService,
    private store: Store<AppState>,
    public dialog: MatDialog,
    private route: ActivatedRoute) {
      this.changeDetectorRef = ref;
      this.dateId = (this.route.snapshot.paramMap.get("id"));
  }

  ngOnInit () {
    this.scheduleControlsHide();
    this.opentokService.initSession().then((session: OT.Session) => {
      this.session = session;
      this.session.on('sessionConnected', (event: any) => {
        this.addRemoteConnections(event.connections || []);
        this.addRemoteStreams(event.streams || []);
      });
      this.session.on('connectionCreated', (event: any) => {
        this.addRemoteConnections([event.connection]);
      });
      this.session.on('connectionDestroyed', (event: any) => {
        this.removeRemoteConnection(event.connection);
      });
      this.session.on('streamCreated', (event) => {
        this.addRemoteConnections([event.stream.connection]);
        this.addRemoteStreams([event.stream]);
      });
      this.session.on('streamDestroyed', (event) => {
        const idx = this.streams.indexOf(event.stream);
        if (idx > -1) {
          this.streams.splice(idx, 1);
          if(!this.changeDetectorRef['destroyed'])
            this.changeDetectorRef.detectChanges();
        }
      });
    })
    .then(() => this.opentokService.connect())
    .catch((err) => {
      console.error(err);
      Swal.fire({
        title: 'No pudimos conectar la videollamada',
        text: 'Revisa tu conexión e intenta entrar nuevamente desde Mis sesiones.',
        icon: 'error',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#24588f',
        customClass: {
          popup: 'video-exit-modal',
          title: 'video-exit-modal__title'
        }
      });
    });

    this.uiSUbscription = this.store.select('ui').subscribe( d=>{
      console.log(d.video)
      this.video = d.video;
    } )

  }

  get hasRemoteConnection(): boolean {
    return this.remoteConnections.length > 0;
  }

  private addRemoteConnections(connections: any[]) {
    let changed = false;

    connections.forEach((connection) => {
      const connectionId = connection?.connectionId;
      const isOwnConnection = this.session?.connection && connectionId === this.session.connection.connectionId;

      if (connectionId && !isOwnConnection && !this.remoteConnections.includes(connectionId)) {
        this.remoteConnections.push(connectionId);
        changed = true;
      }
    });

    if (changed && !this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }
  }

  private removeRemoteConnection(connection: any) {
    const connectionId = connection?.connectionId;
    const idx = this.remoteConnections.indexOf(connectionId);

    if (idx > -1) {
      this.remoteConnections.splice(idx, 1);
      if(!this.changeDetectorRef['destroyed'])
        this.changeDetectorRef.detectChanges();
    }
  }

  private addRemoteStreams(streams: OT.Stream[]) {
    let changed = false;

    streams.forEach((stream) => {
      const alreadyAdded = this.streams.some((currentStream) => currentStream.streamId === stream.streamId);
      const isOwnStream = this.session?.connection && stream.connection?.connectionId === this.session.connection.connectionId;

      if (!alreadyAdded && !isOwnStream) {
        this.streams.push(stream);
        changed = true;
      }
    });

    if (changed && !this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }
  }

  ngOnDestroy(){
    this.clearControlsHideTimer();
    this.opentokService.disconnect();
    this.uiSUbscription.unsubscribe();
    this.streams = [];
    this.remoteConnections = [];
  }

  @HostListener('document:fullscreenchange')
  onFullscreenChange() {
    this.isExpanded = !!document.fullscreenElement;
    this.showControlsTemporarily();
  }

  showControlsTemporarily() {
    this.controlsVisible = true;
    this.scheduleControlsHide();
  }

  private scheduleControlsHide() {
    this.clearControlsHideTimer();
    this.controlsHideTimer = setTimeout(() => {
      this.controlsVisible = false;
      if(!this.changeDetectorRef['destroyed'])
        this.changeDetectorRef.detectChanges();
    }, 3200);
  }

  private clearControlsHideTimer() {
    if (this.controlsHideTimer) {
      clearTimeout(this.controlsHideTimer);
    }
  }

  toggleExpanded() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen?.();
      this.isExpanded = true;
    } else {
      document.exitFullscreen?.();
      this.isExpanded = false;
    }

    this.showControlsTemporarily();
  }

  videoSettings(type) {
    const newVideoSettings = { ...this.video };

    if (type === 'video') {
      newVideoSettings.video = !newVideoSettings.video;
    } else {
      newVideoSettings.audio = !newVideoSettings.audio;
    }

    this.store.dispatch(new SetVideoSettings({ ...newVideoSettings })); // Dispatch con la nueva copia
  }

  endCall(){
    // this.dialog.open(ReviewComponent, {
    //   width:'500px',
    //   height: '500px',
    //   data:{ id:this.dateId }
    // });
    Swal.fire({
      title:'¿Salir de la videollamada?',
      text: 'Podrás volver a entrar mientras la sesión siga activa.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText:'Salir',
      cancelButtonText:'Cancelar',
      confirmButtonColor:'#c8342d',
      cancelButtonColor:'#24588f',
      customClass: {
        popup: 'video-exit-modal',
        title: 'video-exit-modal__title',
        confirmButton: 'video-exit-modal__confirm',
        cancelButton: 'video-exit-modal__cancel'
      }

    }).then((result) => {
      if (result.isConfirmed) this.router.navigate(['/panel/booking']);
    });
  }
}
